import React, { Component } from "react";
import { Auth } from "aws-amplify";


export default class Logout extends Component {
	
	/*
	constructor(props) {
    super(props);
  
  }
*/
  async componentDidMount() {
	  try {
		if (await Auth.currentSession()) {
			this.userHasAuthenticated(true);
			this.props.history.push("/");

		}
	  }
	  catch(e) {
		if (e !== 'No current user') {
		  alert(e);
		}
	  }

	}




  render() {
    return (
<div className="Logout">

	
</div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Logout.js